var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCartDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 14.375H5.45313L3.27344 2.39063C3.24793 2.2471 3.17307 2.11701 3.06179 2.02285C2.95051 1.9287 2.80982 1.8764 2.66406 1.875H1.25",
    stroke: "#646464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 17.5C7.11294 17.5 7.8125 16.8004 7.8125 15.9375C7.8125 15.0746 7.11294 14.375 6.25 14.375C5.38706 14.375 4.6875 15.0746 4.6875 15.9375C4.6875 16.8004 5.38706 17.5 6.25 17.5Z",
    stroke: "#646464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 17.5C15.2379 17.5 15.9375 16.8004 15.9375 15.9375C15.9375 15.0746 15.2379 14.375 14.375 14.375C13.5121 14.375 12.8125 15.0746 12.8125 15.9375C12.8125 16.8004 13.5121 17.5 14.375 17.5Z",
    stroke: "#646464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88281 11.25H14.6953C14.9875 11.2509 15.2706 11.1488 15.4949 10.9616C15.7193 10.7744 15.8704 10.5142 15.9219 10.2266L16.875 5H3.75",
    stroke: "#646464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartDark);
export default __webpack_public_path__ + "static/media/shopping-cart-dark.a68a8f771b247e59748e423fbebe4d0b.svg";
export { ForwardRef as ReactComponent };